import { useCallback, useEffect, useState } from 'react';
import axios from 'axios';
import { toast } from 'sonner';
import { Button } from './ui/button';

const API_URL = process.env.REACT_APP_BACKEND_URL || '';

export function DivergenciasTip({ tipConfigurada }) {
  const [dados, setDados] = useState(null);
  const [erro, setErro] = useState('');
  const [salvando, setSalvando] = useState('');

  const carregar = useCallback(() => {
    if (!tipConfigurada) return;
    setErro('');
    axios.get(`${API_URL}/api/operadora/divergencias`, { withCredentials: true })
      .then(r => setDados(r.data))
      .catch(e => setErro(e.response?.data?.detail || 'Erro ao consultar a Tip'));
  }, [tipConfigurada]);

  useEffect(() => { carregar(); }, [carregar]);

  const agir = async (item, acao) => {
    setSalvando(item.linha_id);
    try {
      await axios.post(`${API_URL}/api/operadora/divergencias/${item.linha_id}/${acao}`, { status_tip: item.status_tip }, { withCredentials: true });
      toast.success(acao === 'aplicar' ? `Linha ${item.numero} agora está ${item.status_sugerido} no sistema` : 'Mantido como está');
      setDados(d => ({ ...d, total: d.total - 1, itens: d.itens.filter(i => i.linha_id !== item.linha_id) }));
    } catch (e) {
      toast.error(e.response?.data?.detail || 'Erro ao salvar');
    } finally {
      setSalvando('');
    }
  };

  return (
    <div className="dashboard-card space-y-3" data-testid="divergencias-tip">
      <div className="flex flex-wrap items-center justify-between gap-3">
        <div>
          <h2 className="section-title mb-1">Diferenças entre a Tip e o sistema {dados ? `(${dados.total})` : ''}</h2>
          <p className="text-xs text-zinc-400">Nada muda sozinho. "Usar status da Tip" altera só o sistema; não bloqueia nem desbloqueia nada na operadora.</p>
        </div>
        <Button variant="outline" className="btn-secondary" onClick={carregar} disabled={!tipConfigurada} data-testid="btn-recarregar-divergencias">Atualizar</Button>
      </div>
      {!tipConfigurada && <p className="text-sm text-zinc-400">Cadastre o token da Tip para ver as diferenças.</p>}
      {erro && <p className="text-sm text-red-400">{erro}</p>}
      {dados && dados.total === 0 && <p className="text-sm text-emerald-400" data-testid="divergencias-vazio">Nenhuma diferença.</p>}
      {dados?.itens?.length > 0 && (
        <div className="table-container overflow-x-auto max-h-[420px]">
          <table className="data-table w-full text-sm">
            <thead><tr>{['Cliente', 'Número', 'No sistema', 'Na Tip', ''].map(h => <th key={h}>{h}</th>)}</tr></thead>
            <tbody>
              {dados.itens.map(i => (
                <tr key={i.linha_id} data-testid={`divergencia-${i.linha_id}`}>
                  <td>{i.cliente_nome}<div className="text-xs text-zinc-500">{i.plano_tip}</div></td>
                  <td className="font-mono">{i.numero}</td>
                  <td>{i.status_sistema}</td>
                  <td className="text-amber-300">{i.status_tip}</td>
                  <td className="whitespace-nowrap space-x-2 text-right">
                    <Button size="sm" className="h-7 text-xs btn-primary" disabled={salvando === i.linha_id} onClick={() => agir(i, 'aplicar')} data-testid={`aplicar-${i.linha_id}`}>Usar status da Tip</Button>
                    <Button size="sm" variant="outline" className="h-7 text-xs" disabled={salvando === i.linha_id} onClick={() => agir(i, 'ignorar')} data-testid={`ignorar-${i.linha_id}`}>Manter</Button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
